import * as React from 'react';
import { Alert } from 'react-bootstrap';

interface ListErrorsProps {
  errors: any;
}

export default class ListErrors extends React.Component<ListErrorsProps> {
  public render() {
    const errors = this.props.errors;
    if (errors) {
      return (
        <Alert bsStyle="warning">
          <ul className="error-messages">
            {Object.keys(errors).map((key) => {
              if (errors[key]) {
                return (
                  <li key={key}>
                    {key}: {errors[key]}
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </Alert>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ListErrors.tsx